import CrudTable from "../CrudTable";
import { useAuth } from "../../context/AuthContext";
import { canFinEdit } from "../../lib/roles";

const key = (s) => String(s || "").trim().toLocaleLowerCase("tr");
export const BANK_DEFAULTS = { name: "", company: "", branch: "", account_no: "", iban: "", branch_email: "", branch_phone: "", manager_name: "", manager_phone: "", manager_email: "", rep_name: "", rep_phone: "", rep_email: "", ops_name: "", ops_phone: "", ops_email: "" };

// Banka kartı iletişim bilgileri alt alta: Şube Müdürü · Müşteri Temsilcisi · Şube · Operasyon Yetkilisi
export function BankContacts({ b }) {
  const rows = [
    ["Şube Müdürü", b.manager_name, b.manager_phone, b.manager_email],
    ["Müşteri Temsilcisi", b.rep_name, b.rep_phone, b.rep_email],
    ["Şube", "", b.branch_phone, b.branch_email],
    ["Operasyon Yetkilisi", b.ops_name, b.ops_phone, b.ops_email],
  ].filter((r) => r[1] || r[2] || r[3]);
  if (!rows.length) return <span className="text-slate-400">—</span>;
  return (
    <div className="space-y-0.5" data-testid={`bank-contacts-${b.id}`}>
      {rows.map(([label, name, phone, email]) => (
        <div key={label} className="text-[11px] leading-tight">
          <span className="font-semibold text-slate-700">{label}:</span> {name && <span>{name}</span>}{phone && <span className="text-slate-500"> · {phone}</span>}{email && <span className="text-sky-700" data-no-upper> · {email}</span>}
        </div>
      ))}
    </div>
  );
}

const F = (k, label, type = "text") => ({ key: k, label, type, required: false });
const EMAIL_FIELDS = ["manager_email", "rep_email", "branch_email", "ops_email"];
// e-postası olmayan banka → limit revize hatırlatması bankaya gönderilemez (kırmızı işaret)
export const bankHasEmail = (b) => EMAIL_FIELDS.some((f) => String(b?.[f] || "").trim());
const NoMailBadge = ({ b }) => <span className="ml-1 px-1 py-0.5 rounded bg-red-600 text-white text-[9px] font-bold align-middle" data-testid={`bank-nomail-${b.id}`} title="E-posta yok — limit revize hatırlatma maili bu bankaya gönderilemez; şube / müdür / temsilci / operasyon e-postasından en az birini girin">E-POSTA YOK</span>;

// Sabit Tanımlar → Bankalar ve Mali Veriler → Banka Kartları tarafından ortak kullanılır; düzenleme: Yönetici / Muhasebe / Finans
export default function BankCardsTable() {
  const { user } = useAuth();
  return (
    <CrudTable
      resource="banks" title="" subtitle="" testidPrefix="bank" readOnly={!canFinEdit(user)}
      defaults={BANK_DEFAULTS}
      toolbar={(items) => { const n = items.filter((b) => !bankHasEmail(b)).length; return n ? <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-md border border-red-300 bg-red-50 text-xs font-semibold text-red-800" data-testid="bank-nomail-count">{n} banka kaydında e-posta yok — limit revize hatırlatması bu bankalara gönderilemez (kırmızı işaretli satırlar)</div> : null; }}
      columns={[
        { key: "name", label: "Banka Adı", render: (b) => <span className={bankHasEmail(b) ? "" : "text-red-700 font-semibold"}>{b.name}{!bankHasEmail(b) && <NoMailBadge b={b} />}</span> },
        { key: "company", label: "Firma" },
        { key: "branch", label: "Şube" },
        { key: "account_no", label: "Hesap No" },
        { key: "iban", label: "IBAN" },
        { key: "contacts", label: "İletişim (Şube Müdürü · Müşteri Temsilcisi · Şube · Operasyon) — aynı banka/şube için tüm firmalara otomatik kopyalanır", render: (b) => <><BankContacts b={b} />{!bankHasEmail(b) && <div className="text-[11px] text-red-700 font-semibold mt-0.5" data-testid={`bank-nomail-note-${b.id}`}>E-posta yok — revize maili bankaya gidemez</div>}</>, values: (b) => [b.manager_email, b.rep_email, b.branch_email, b.ops_email].filter(Boolean) },
      ]}
      fields={[
        {
          key: "name", label: "Banka Adı", type: "text",
          validate: (v, f, items, editId) => {
            if (!String(v || "").trim()) return "Banka adı zorunludur";
            if (items.some((i) => i.id !== editId && key(i.name) === key(v) && key(i.company) === key(f.company) && key(i.branch) === key(f.branch))) return "Bu banka/şube kaydı zaten mevcut";
            return "";
          },
        },
        F("company", "Firma"), F("branch", "Şube Adı"), F("account_no", "Hesap No"), F("iban", "IBAN"),
        F("branch_phone", "Şube Telefonu", "tel"), F("branch_email", "Şube E-posta", "email"),
        F("manager_name", "Şube Müdürü Ad Soyad"), F("manager_phone", "Şube Müdürü Telefon", "tel"), F("manager_email", "Şube Müdürü E-posta", "email"),
        F("rep_name", "Müşteri Temsilcisi Ad Soyad"), F("rep_phone", "Müşteri Temsilcisi Telefon", "tel"), F("rep_email", "Müşteri Temsilcisi E-posta", "email"),
        F("ops_name", "Operasyon Yetkilisi Ad Soyad"), F("ops_phone", "Operasyon Yetkilisi Telefon", "tel"), F("ops_email", "Operasyon Yetkilisi E-posta", "email"),
      ]}
    />
  );
}
